/**
 * TanStack Query hooks for `fbclid-msclkid-ttclid-parallel-tracking-cross-netw`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fbclidMsclkidTtclidParallelTrackingCrossNetwQueryKeys,
	type CreateFbclidMsclkidTtclidParallelTrackingCrossNetwBody,
	type ListFbclidMsclkidTtclidParallelTrackingCrossNetwResponse,
	type FbclidMsclkidTtclidParallelTrackingCrossNetwRow,
} from "./api";

export function useFbclidMsclkidTtclidParallelTrackingCrossNetwList(): UseQueryResult<ListFbclidMsclkidTtclidParallelTrackingCrossNetwResponse, Error> {
	return useQuery({
		queryKey: fbclidMsclkidTtclidParallelTrackingCrossNetwQueryKeys.list(),
		queryFn: list,
	});
}

export function useFbclidMsclkidTtclidParallelTrackingCrossNetwCreate(): UseMutationResult<FbclidMsclkidTtclidParallelTrackingCrossNetwRow, Error, CreateFbclidMsclkidTtclidParallelTrackingCrossNetwBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fbclidMsclkidTtclidParallelTrackingCrossNetwQueryKeys.all });
		},
	});
}

export function useFbclidMsclkidTtclidParallelTrackingCrossNetwDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fbclidMsclkidTtclidParallelTrackingCrossNetwQueryKeys.all });
		},
	});
}
